// TODO check it
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Divider from 'material-ui/Divider'

import Badge from 'components/Badge'

import sectionsActions from 'actions/sections'

let select = (state, props) => ({
	expanded: state.sections[props.id] !== undefined ? state.sections[props.id] : false
  , accordion: state.accordion
})

export class Section extends Component{
	render(){
		let { props } = this
		let expanded=props.accordionID && props.accordionID!=props.accordion?false:(props.needBeExpanded || props.expanded)
		return(
			<div className="Section" style={{marginBottom: expanded?"10px":"0", marginTop:expanded && !props.top?"10px":"0"}}>
				<Divider style={{margin: "0"}}/>
				<Card
					style={{
						boxShadow:expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)"
					}}
					expanded={expanded}
					onExpandChange={(expanded)=> props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || expanded, accordion: props.accordionID})}
				>
					<CardHeader
						titleStyle={{padding:"0"}}
						title={
							<table style={{width:expanded ?"calc(105%)":"calc(115%)", height: "52px"}}>
								<tr>
									<td
										style={{
											cursor:"pointer"
										  , padding: "16px"
										  , whiteSpace: "nowrap"
										  , position: "relative"
										  , maxWidth: expanded ?"250px":"250px"
										  , overflow: "hidden"
										}}
										onClick={()=> props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || !expanded, accordion: props.accordionID})}
									>
										{props.title}

									</td>
									<td
										style={{width:expanded ?"100px":"30px", right:"-5px", padding: "16px 0", height:"100%", whiteSpace: "nowrap", textAlign: "right"}}
										onClick={()=> {!expanded && props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || !expanded, accordion: props.accordionID})}}
									>
										{expanded ? <div style={{float: "right", position:"absolute", right:"55px", top:"10px"}}>{props.rightButton}</div>
										:<span
											style={{
												height: "20px"
												, position:"absolute"
												, top:"15px"
												, float: "right"
												, right:"20px"
											}}
										>
											<div
												style={{width: "100%"}}
												onClick={()=> props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || !expanded, accordion: props.accordionID})}
											>
												{props.badge>0 &&<Badge
													 badgeContent={props.badge}
													 secondary={props.badge>0}
												/>}
											</div>
										</span>
										}
									</td>
								</tr>
							</table>
						}
						textStyle={{width: "100%"}}
						style={{padding:"0px"}}
						showExpandableButton={expanded && !props.needBeExpanded}
					/>
					<CardText expandable={true} style={{marginTop:"-20px", marginBottom:"-20px"}}>
						{props.children}
					</CardText>
				</Card>
			</div>
		)
	}
}

export default connect(select, sectionsActions)(Section)



// WEBPACK FOOTER //
// ./src/components/Communication/SectionDiscussion.js